import React, { useEffect, useState, useRef } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import * as influencerReviewAction from "../../redux/actions/influencerReview";
import ReactPaginate from "react-paginate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faXmark,
  faCalendarDays,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import NoDataFound from "../../reUsable/NoDataFound";
import { Col, Row } from "react-bootstrap";
import {
  Spin,
  Modal,
  Button,
  Form,
  Input,
  Upload,
  message,
  Select,
  notification,
  Avatar,
  Table,
  DatePicker,
  InputNumber,
} from "antd";
import "video-react/dist/video-react.css";
import AsyncProduct from "../create-event/scheduleEvent/asyncProduct";
import GroupIcon from "@mui/icons-material/Group";
import Typography from "@mui/material/Typography";
import Swal from "sweetalert2";
import { getAllCreator } from "../../redux/actions/influencerReview";
import ReactPlayer from "react-player";
import LoadingSpin from "../../reUsable/loadingSpin";
import {
  getSavedGeneralCategories,
  getSavedCategories,
  getSavedSubCategories,
} from "../../redux/actions/newCategory.action";
import AsyncInfluencer from "./asyncInfluencer";

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

function LinkProducts({
  getInfluencerReview,
  getInfluencerVideo,
  linkInfluencerProduct,
  reviewDeleted,
}) {
  const dispatch = useDispatch();
  const {
    parentCategory,
    getAllCreatorData,
    promoRequest,
    reactS3BucketData,
    savedGeneralCategories,
  } = useSelector((state) => {
    return state;
  });
  const childRef = useRef();
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);
  const [videoData, setVideoData] = useState("");

  const [banner, setBanner] = useState([]);
  const [sku, setSku] = useState([]);
  const [skuError, setSkuError] = useState(false);
  const [parent, setParent] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [dataDetails, setDataDetail] = useState([]);
  const [isModalOpenDetail, setIsModalOpenDetail] = useState(false);
  const [flag, setFlag] = useState(false);
  const [productPromoCodeDscs, setProductPromoCodeDscs] = useState("0%");
  const [productPromoCodePromo, setproductPromoCodePromo] = useState("KB0");
  const [referralPercent, setReferralPercent] = useState("0");
  // const fromDate = moment().startOf('year').format('YYYY-MM-DD');
  // const toDate = moment(new Date()).format("YYYY-MM-DD");
  const fromDate = moment().startOf("month").format("YYYY-MM-DD");
  const toDate = moment().endOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(fromDate);
  const [endDate, setEndDate] = useState(toDate);
  const [influencerId, setInfluencerId] = useState("");
  const [influencer, setInfluencer] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [sortBy, setSortBy] = useState("date");
  const limit = 8;
  const firstRender = useRef(true);

  const [gender, setGender] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [genLoading, setGenLoading] = useState(true);

  const [form] = Form.useForm();

  useEffect(() => {
    getInfluencerReview(
      "active",
      1,
      limit,
      startDate,
      endDate,
      influencerId,
      sortBy
    ).then((res) => {
      firstRender.current = false;
      setLoading(false);
    });
    // dispatch(getParentCategories()).then((res) => {
    //   if (res.payload.success) {
    //     // setLoading(false);
    //   } else {
    //     // setLoading(false);
    //   }
    // });
    dispatch(getSavedGeneralCategories()).then((res) => {
      if (res.success) {
        setGenLoading(false);
      } else {
        setGenLoading(false);
      }
    });
    dispatch(getAllCreator()).then((res) => {
      if (res.payload.success) {
        // setLoading(false);
      } else {
        // setLoading(false);
      }
    });
  }, []);
  console.log("reactS3BucketData", reactS3BucketData);
  useEffect(() => {
    if (!firstRender.current) {
      setTimeout(() => {
        setLoading(true);
        getInfluencerReview(
          "active",
          1,
          limit,
          startDate,
          endDate,
          influencerId,
          sortBy
        ).then(() => setLoading(false));
      }, 3000);
    }
  }, [reactS3BucketData]);

  const onLinkProduct = async (item) => {
    setShowPlayer(true);
    setVideoData(item);
  };
  function intlFormat(num) {
    return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
  }
  function numberFormat(num) {
    if (num >= 1000000) return intlFormat(num / 1000000) + "M";
    if (num >= 1000) return intlFormat(num / 1000) + "k";
    return intlFormat(num);
  }
  const changePromoCode = (e, options, name, index) => {
    if (e === undefined) {
    } else {
      var values = e.value.split(" ");
      var discount = values[0];

      setProductPromoCodeDscs(discount);
      setproductPromoCodePromo(e.children);
    }
  };
  function onDelete(seletedItem) {
    // setCurrentData(seletedItem);
    Swal.fire({
      title: "Are You Sure?",
      text: "You Want To Remove This Review?",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#000080",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        setDeleteLoading(true);
        reviewDeleted({
          review_id: seletedItem._id,
          status: "delete",
        })
          .then(() => {
            setDeleteLoading(false);
            notification.success({
              message: "Successfully Removed Review",
              className: "toast-success",
            });
            setLoading(true);
            getInfluencerReview(
              "active",
              1,
              limit,
              startDate,
              endDate,
              influencerId,
              sortBy
            ).then(() => setLoading(false));
          })
          .catch((err) => {
            setDeleteLoading(false);
            notification.error({
              message: err.response.message,
              className: "toast-error",
            });
          });
      }
    });
  }

  function renderContent() {
    if (!loading) {
      return (
        <Row className="post-analytics-tab-boxes-ift influencer-reviews-main ">
          {getInfluencerVideo?.data?.length > 0 ? (
            getInfluencerVideo?.data?.map((item, i) => (
              <Col xs={12} xl={3} md={6}>
                <div
                  key={i}
                  className={`card any_bx analytic-box campaign-box pb-0`}
                >
                  <div className="camp-row row">
                    <div className="campaign-header col-12">
                      <div className="inf-header">
                        {/* <span className="review-box-header mr-2">
                          {item?.influencer?.profile_image_url ? (
                            <Avatar
                              icon={<UserOutlined />}
                              src={item?.influencer?.profile_image_url}
                            />
                          ) : (
                            <Avatar icon={<UserOutlined />} />
                          )}
                        </span> */}
                        <div className="inf-username-box">
                          {item?.influencer?.name ? (
                            <a
                              title={item?.influencer?.name}
                              className="inf-username"
                              target="_blank"
                              href={`https://www.instagram.com/${item?.influencer?.name}`}
                            >
                              {item?.influencer?.name.length > 20
                                ? item?.influencer?.name.slice(0, 20) + "..."
                                : item?.influencer?.name}
                            </a>
                          ) : item?.influencer?.insta_handle ? (
                            <a
                              title={item?.influencer?.insta_handle}
                              className="inf-username"
                              target="_blank"
                              href={`https://www.instagram.com/${item?.influencer?.insta_handle}`}
                            >
                              @
                              {item?.influencer?.insta_handle?.length > 20
                                ? item?.influencer?.insta_handle.slice(0, 20) +
                                  "..."
                                : item?.influencer?.insta_handle}
                            </a>
                          ) : (
                            <a
                              title={item?.influencer?.ig_handle}
                              className="inf-username"
                              target="_blank"
                              // href={`https://www.instagram.com/${item?.influencer?.ig_handle}`}
                            >
                              {/* @ */}
                              {item?.influencer?.name?.length > 20
                                ? item?.influencer?.name.slice(0, 20) + "..."
                                : item?.influencer?.name}
                            </a>
                            // <span
                            //   className="inf-username"
                            //   title={item?.influencer?.name}
                            // >
                            //   {item?.influencer?.name}
                            // </span>
                          )}
                          {/* <span className="inf-email">{item?.influencer?.email}</span> */}
                          {/* <span className="inf-email">Followers: 10</span> */}
                        </div>

                        {/* <div className="inf-head-followers">
                          <GroupIcon className="fol-icon" />
                          <h5>
                            {item?.influencer?.followers
                              ? numberFormat(item?.influencer?.followers)
                              : 0}
                          </h5>
                        </div> */}
                      </div>
                    </div>
                    <div className="any-post-img-col col-12">
                      <div className="any-post-image media-post-new">
                        {item?.media_url ? (
                          <div className="any-image-box">
                            <div className="any-image-box-iner review-video">
                              <div className="review-video">
                                <ReactPlayer
                                  className={`review_react_player ${
                                    item?.media_url?.split(".")[
                                      item?.media_url?.split(".")?.length - 1
                                    ] === "m3u8" && "objectFit"
                                  }`}
                                  width={"100%"}
                                  height={"250px"}
                                  url={item?.media_url}
                                  controls
                                  light={item?.banner}
                                  playsinline
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="d-flex justify-content-center align-items-center w-100 h-100 media-processing">
                              {reactS3BucketData?.payload?.length === 0 ||
                              reactS3BucketData?.length === 0 ? (
                                <>
                                  <div className="d-flex">
                                    <span className="spinclass spin-color position-relative mr-3">
                                      <Spin className="" />
                                    </span>
                                    <div className="process-hd ff-nunito">
                                      Media Processing
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <div className="process-hd ff-nunito">
                                  Media Processed!
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="inf-content-area">
                      <div className="event-date-main top-date">
                        <div className="event-date">
                          <FontAwesomeIcon
                            className="event-icon"
                            icon={faCalendarDays}
                          />
                          <div className="event-txt">
                            {moment(item?.created_at)
                              .utc()
                              .format("YYYY-MM-DD")}
                          </div>
                        </div>

                        <div className="event-date">
                          <FontAwesomeIcon
                            className="event-icon"
                            icon={faClock}
                          />

                          <div className="event-txt">
                            {moment(item?.created_at).format("hh:mm A")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cam-buttons col-12">
                    {/* {deleteLoading ? (
                      <button className="btn">
                        <span className="spinclass loader-center position-relative">
                          <Spin size="small" />
                        </span>
                      </button>
                    ) : (
                      <button
                        className="default-btn medium-btn padb-3 m-0 w-inherit"
                        onClick={() => {
                          onLinkProduct(item);
                        }}
                      >
                        <i className="fa fa-link mr-2" />
                        Link Product
                      </button>
                    )}{" "} */}
                    {item?.media_url && (
                      <button
                        className="default-btn medium-btn padb-3 m-0 w-inherit"
                        onClick={() => {
                          onLinkProduct(item);
                        }}
                      >
                        <i className="fa fa-link mr-2" />
                        Link Product
                      </button>
                    )}
                    <button
                      className="default-btn medium-btn padb-3 mr-0 w-inherit"
                      onClick={() => onDelete(item)}
                      disabled={deleteLoading}
                    >
                      <i class="fa fa-trash" /> Delete
                    </button>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <div className="col-md-12">
              <NoDataFound />
            </div>
          )}
        </Row>
      );
    } else {
      return <LoadingSpin />;
    }
  }

  const handlePageClick = (e) => {
    setLoading(true);
    const page = e.selected;
    setCurrentPage(page);
    getInfluencerReview(
      "active",
      page + 1,
      limit,
      startDate,
      endDate,
      influencerId,
      sortBy
    ).then(() => setLoading(false));
  };

  const handleCancel = () => {
    setShowPlayer(false);
    setBanner([]);
    setSku([]);
    setSubCategoryOptions([]);
    setCategoryOptions([]);
    setCategory("");
    setSubCategory("");
    setGender("");
    form.resetFields();
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    listType: "picture",
    // fileList={fileList}
    maxCount: 1,
    action: "https://httpbin.org/post",

    beforeUpload: (file) => {
      const isPNG =
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/svg+xml" ||
        file.type === "image/svg";

      if (!isPNG) {
        message.error(`${file?.name} is not a valid format`);
      }

      return isPNG || Upload.LIST_IGNORE;
    },

    onChange(info) {
      const { status } = info?.file;
      setBanner(info?.file?.originFileObj);

      if (status === "done") {
        message.success(`${info?.file.name} Image uploaded successfully.`);
      } else if (status === "error") {
        // message.error(`${info.file.name} file upload failed.`);
      }
    },

    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },

    onRemove(e) {
      // console.log(e, "onRemove");
      // return Upload.LIST_IGNORE;
      // setPreviewImage('');
    },
  };

  const onFinish = (val) => {
    const { title, gen_category_id, category_id, sub_category_id } = val;
    if (sku.length === 0) {
      setSkuError(true);
    } else {
      let newSku = sku.map((skuItem) => {
        return {
          ...skuItem,
          referral_percent: referralPercent ? referralPercent : "0",
        };
      });
      let formData = new FormData();
      formData.append("image", banner);
      formData.append("media_url", videoData?.media_url);
      formData.append("media_library_id", videoData?._id);
      formData.append("title", title);
      formData.append("gen_category_id", gen_category_id);

      // if (category_id !== "all") {
      formData.append("category_id", category_id ? category_id : "all");
      // }
      // if (sub_category_id !== "all") {
      formData.append("sub_category_id", sub_category_id ? sub_category_id : "all");
      // }
      formData.append("products", JSON.stringify(newSku));
      formData.append("discount", productPromoCodeDscs);
      formData.append("promo", productPromoCodePromo);
      formData.append(
        "referral_percent",
        referralPercent > 0 ? referralPercent : 0
      );
      setSaveLoading(true);
      linkInfluencerProduct(formData).then((res) => {
        if (res.payload.success) {
          notification.success({
            message: res.payload?.message,
            className: "toast-success",
          });
          setShowPlayer(false);
          setBanner([]);
          setSku([]);
          setSaveLoading(false);
          setLoading(true);
          setGender("");
          setSubCategoryOptions([]);
          setCategoryOptions([]);
          setCategory("");
          setSubCategory("");
          getInfluencerReview(
            "active",
            1,
            limit,
            startDate,
            endDate,
            influencerId,
            sortBy
          ).then(() => setLoading(false));
        } else {
          setSaveLoading(false);
          notification.error({
            message: res.payload?.data?.message,
            className: "toast-error",
          });
        }
      });
    }
  };

  const getSku = (skuData) => {
    setSkuError(false);
    setSku(skuData);
  };

  const handleCategory = (e) => {
    let parent = parentCategory?.payload?.message.filter(
      (item) => item.category_id == e
    );
    setParent(parent[0]?.category_name);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: 60,
      render: (text, record, index) => {
        return <p>{index + 1}</p>;
      },
    },
    {
      title: "SKU",
      dataIndex: "ProductSku",
      key: "ProductSku",
      width: 60,
    },
    {
      title: "IMAGE",
      dataIndex: "mediaUrl",
      key: "mediaUrl",
      width: 70,
      render: (text, record) => {
        return (
          <div className="listing-image">
            <img src={`${record.mediaUrl}`} />
          </div>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "productDesc",
      key: "productDesc",
      width: 250,
      render: (text, record) => {
        return (
          <div className="desc-limit">
            {record.productDesc.length > 70
              ? record.productDesc.slice(0, 70) + "..."
              : record.productDesc}
          </div>
        );
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 80,
    },
    // {
    //   title: 'Stock',
    //   dataIndex: 'stock',
    //   key: 'stock',
    //   width: 80,
    //   render: (text, record) => {
    //     return (

    //       <p>21</p>

    //     );
    //   },
    // },
    // {
    //   title: 'Discount',
    //   dataIndex: 'discount',
    //   key: 'discount',
    //   width: 80,
    //   // render: (text, record) => {
    //   //   return (

    //   //     <p>0</p>

    //   //   );
    //   // },
    // },

    // {
    //     title: 'Balance',
    //     dataIndex: 'balance',
    //     key: 'balance',
    //     width: 80
    // },
    {
      title: "Balance",
      dataIndex: "event",
      key: "event",
      width: 140,
      render: (text, record) => (
        <>
          <div className="balance-area">
            <div className="balance-count">
              {record?.variants?.reduce((acc, item) => {
                return (acc = acc + item.inventory_quantity);
              }, 0)}
            </div>
            <div className="balance-area">
              <a
                className="balance-btn default-btn outline small-btn"
                onClick={() => {
                  showModalDetail(record);
                }}
              >
                View
                {/* <FontAwesomeIcon icon={faEye} /> */}
              </a>
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "event",
      key: "event",
      width: 100,
      render: (text, record) => {
        let status = record?.variants?.reduce((acc, item) => {
          return (acc = acc + item.inventory_quantity);
        }, 0);
        if (status >= 70) {
          return (
            <div className="status-info">
              <div className="status-flag green"></div>
              {/* <p>green</p> */}
            </div>
          );
        } else if (status >= 50 && status <= 70) {
          return (
            <div className="status-info">
              <div className="status-flag yellow"></div>
              {/* <p>yellow</p> */}
            </div>
          );
        } else if (status <= 50) {
          return (
            <div className="status-info">
              <div className="status-flag red"></div>
              {/* <p>red</p> */}
            </div>
          );
        } else {
          return null;
        }
      },
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   fixed: 'right',
    //   width: 100,
    //   className: 'text-left',
    //   // sorter: true,
    //   render: (text, record, index) => {

    //     return (
    //       <Space size="middle" className="actions-list">
    //         {/* <DeleteFilled onClick={() => alert("Sure!")} /> */}
    //         <Switch
    //           disabled={isModalOpen}
    //           size="small"
    //           checked={record?.is_active}
    //           onChange={() => onToggle(record, index)}
    //         // checkedChildren="Fixed Top"
    //         // unCheckedChildren="Fixed Top"

    //         // onChange={() => {
    //         //   setFixedTop(!fixedTop);
    //         // }}
    //         />
    //       </Space>
    //     )
    //   },
    // }
  ];

  const onToggle = (record, recInd) => {
    if (record?.is_active == true) {
      record.is_active = false;
      let obj = record;
      const key = { ...obj };
      key.is_active = false;

      setSku((current) =>
        current.map((obj, index) => {
          if (index == recInd) {
            return { ...obj, is_active: false };
          }
          return obj;
        })
      );
    } else {
      record.is_active = true;
      let obj = record;
      const key = { ...obj };
      key.is_active = true;
      setSku((current) =>
        current.map((obj, index) => {
          if (index == recInd) {
            return { ...obj, is_active: true };
          }
          return obj;
        })
      );
    }

    // record.is_active = checked;
  };

  const showModalDetail = (s) => {
    setDataDetail(s.variants);
    setIsModalOpenDetail(true);
  };

  const handleCancelDetail = () => {
    setIsModalOpenDetail(false);
  };

  const handleOkDetail = () => {
    setIsModalOpenDetail(false);
  };

  const columnDetails = [
    {
      title: "Size",
      key: "option1",
      dataIndex: ["option1"],
      width: 40,
      render: (text, record, index) => {
        return (
          <>
            <div className=""> {record?.option1 ? record?.option1 : "-"} </div>
          </>
        );
      },
    },

    {
      title: "Wash",
      key: "option1",
      dataIndex: ["option1"],
      width: 100,
      render: (text, record, index) => {
        return (
          <>
            <div className=""> {record?.option2 ? record?.option2 : "-"} </div>
          </>
        );
      },
    },

    {
      title: "Inseam",
      key: "option1",
      dataIndex: ["option1"],
      width: 70,
      render: (text, record, index) => {
        return (
          <>
            <div className="">{record?.option3 ? record?.option3 : "-"} </div>
          </>
        );
      },
    },

    {
      title: "Stock",
      dataIndex: "inventory_quantity",
      key: "inventory_quantity",
      width: 60,
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    const page = e.selected;
    setCurrentPage(0);
    setLoading(true);
    getInfluencerReview(
      "active",
      1,
      limit,
      startDate,
      endDate,
      influencerId,
      sortBy
    ).then(() => {
      setLoading(false);
      setInfluencer("");
    });
  };

  const handleReset = () => {
    setInfluencerId("");
    // moment().startOf('year').format('YYYY-MM-DD');
    // setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
    setStartDate(fromDate);
    // setEndDate(moment(new Date()).format("YYYY-MM-DD"));
    setEndDate(toDate);
    setLoading(true);
    setSortBy("date");
    childRef.current?.clear();
    getInfluencerReview(
      "active",
      1,
      limit,
      // moment().startOf('year').format('YYYY-MM-DD'),
      fromDate,
      // moment(new Date()).format("YYYY-MM-DD"),
      toDate,
      "",
      "date"
    ).then(() => {
      setLoading(false);
      setInfluencer("");
    });
  };

  const handleSortBy = (value) => {
    setSortBy(value);
  };

  const dateRangePickerChanger = (value, dataString) => {
    const startDate = dataString[0];
    const endDate = dataString[1];
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleCreator = (value, option) => {
    setInfluencerId(value);
  };

  const getInfluencer = (influencerData, influencerUsername, insta_handle) => {
    setInfluencerId(influencerData);
  };

  const onGenderChange = (value) => {
    setGender(value);
    setSubCategoryOptions([]);
    setCategoryOptions([]);
    setCategory("");
    setSubCategory("");
    form.setFieldsValue({ category_id: undefined, sub_category_id: undefined });
    const data = value === "all" ? "" : value;
    setGenLoading(true);
    dispatch(getSavedCategories(data)).then((res) => {
      if (res.success) {
        setCategoryOptions(res?.message);
        setGenLoading(false);
      } else {
        setGenLoading(false);
      }
    });
  };

  const onCategoryChange = (value) => {
    setSubCategory([]);
    setSubCategoryOptions([]);
    setSubCategory("");
    form.setFieldsValue({ sub_category_id: undefined });
    const data = value === "all" ? "" : value;
    dispatch(getSavedSubCategories(gender === "all" ? "" : gender, data)).then(
      (res) => {
        if (res.success) {
          setSubCategoryOptions(res?.message);
          // setCatLoad(false)
        } else {
          // setCatLoad(true)
        }
      }
    );
  };

  const onSubCategoryChange = (value) => {
    setSubCategory(value);
  };

  return (
    <div className="container-fluid p-0">
      <div className="row w-20-desktop-main">
        <div className="col-xl-3 col-md-6 col-12 mb-15">
          <p className="mb-5rem">Select Start Date / End Date</p>
          <RangePicker
            size="large"
            className="w-100"
            key={4}
            value={
              startDate && endDate ? [moment(startDate), moment(endDate)] : []
            }
            allowClear={false}
            ranges={{
              // Today: [moment(), moment()],
              // Tomorrow: [
              //   moment().add(1, 'days'),
              //   moment().add(1, 'days'),
              // ],
              // Yesterday: [
              //   moment().subtract(1, 'days'),
              //   moment().subtract(1, 'days'),
              // ],
              "Last Year": [
                moment().subtract(1, "year").startOf("year"),
                moment().subtract(1, "year").endOf("year"),
              ],
              "This Year": [moment().startOf("year"), moment().endOf("year")],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
              "This Month": [
                moment().startOf("month"),
                moment().endOf("month"),
              ],
            }}
            format={dateFormat}
            onChange={dateRangePickerChanger}
          />
        </div>
        <div className="col-xl-3 col-md-6 col-12 mb-15">
          <p className="mb-5rem">Select Creator</p>
          {/* <AsyncInfluencer
            ref={childRef}
            getInfluencer={getInfluencer}
            influencer={influencer}
          /> */}
          <AsyncInfluencer
            ref={childRef}
            getInfluencer={getInfluencer}
            influencer={influencer}
          />
        </div>
        <div className="col-xl-3 col-md-6 col-12 mb-15">
          <p className="mb-5rem">Sort By</p>
          <Select
            className="w-100 select-style dark-field"
            placeholder="Select Sort By"
            size="large"
            // focus={false}
            // onBlur={false}
            onChange={handleSortBy}
            value={sortBy}
          >
            <Option value="date">Date</Option>
            <Option value="follower">Followers</Option>
          </Select>
        </div>
        <div className="col-xl-3 col-md-6 col-12 d-flex align-items-end mb-15">
          <Button
            onClick={handleSubmit}
            className="default-btn fltr-hpr  medium-btn m-width-100 ml-0 fw-normal"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Search
          </Button>

          <Button
            onClick={handleReset}
            className="default-btn outline fw-normal fltr-hpr medium-btn  res-btn2 min-w-100"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            Reset
          </Button>
        </div>
      </div>
      <hr className="separator-line mt-0" />
      {renderContent()}
      {getInfluencerVideo?.data?.length > 0 && !loading && (
        <ReactPaginate
          previousLabel={<FontAwesomeIcon icon={faAngleLeft} />}
          nextLabel={<FontAwesomeIcon icon={faAngleRight} />}
          pageClassName="page-item "
          pageLinkClassName="page-link custom-paginate-link btn btn-primary"
          previousClassName="page-item"
          previousLinkClassName="page-link custom-paginate-prev btn btn-primary"
          nextClassName="page-item"
          nextLinkClassName="page-link custom-paginate-next btn btn-primary"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          forcePage={currentPage}
          pageCount={Math.ceil(getInfluencerVideo.total_count / limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={window.innerWidth <= 760 ? 1 : 7}
          onPageChange={handlePageClick}
          containerClassName={
            "pagination justify-content-center mt-2 custom-paginate review-paginate"
          }
          activeClassName={"active"}
        />
      )}
      {showPlayer && (
        <Modal
          className="modal-generic modal-800"
          centered
          visible={showPlayer}
          // onOk={handleOk}
          onCancel={handleCancel}
          closeIcon={<FontAwesomeIcon icon={faXmark} />}
          footer={false}
          maskClosable={false}
          keyboard={false}
        >
          <h2 className="modal-hd1">Link Product</h2>
          <Form
            // layout="vertical"
            form={form}
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div class="row">
              <div className="col-md-7 modal-review-right">
                <div className="form-styling">
                  <Form.Item
                    name="title"
                    labelCol={{ span: 24 }}
                    label="Video Title"
                    rules={[
                      {
                        required: true,
                        message: "Please enter video title",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Video Title"
                      // value={"test.myshopify.com"}
                      // value="dl1961denim"
                      size="large"
                      // onChange={onChange}
                    />
                  </Form.Item>
                </div>
                <div className="form-styling">
                  {/* <Form.Item
                    labelCol={{ span: 24 }}
                    // initialValue={
                    //   formState === "add" ? undefined : form.getFieldValue().category_id
                    // }
                    // initialValue={form.getFieldValue().category_id}
                    label="Category"
                    name="category_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a category",
                      },
                    ]}
                  >
                    <Select
                      className="select-style dark-field"
                      placeholder="Select Category"
                      size="large"
                      focus={false}
                      onChange={handleCategory}
                      onBlur={false}
                      loading={parentCategory?.loading ? true : false}
                      disabled={parentCategory?.loading ? true : false}
                    >
                      {parentCategory?.payload?.message.map((item, i) => {
                        return (
                          <Option value={item.category_id}>
                            {item.category_name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item> */}
                  <Form.Item
                    labelCol={{ span: 24 }}
                    // initialValue={form.getFieldValue().gen_category_id}
                    label="Department"
                    name="gen_category_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a department",
                      },
                    ]}
                  >
                    <Select
                      className="select-style dark-field"
                      placeholder="Select Department"
                      size="large"
                      focus={false}
                      onBlur={false}
                      onChange={onGenderChange}
                      value={gender}
                      loading={genLoading}
                      disabled={genLoading}
                    >
                      {savedGeneralCategories?.message?.map((option) => {
                        return (
                          <Option value={option?.category_id}>
                            {option?.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                  {categoryOptions?.length ? (
                    <Form.Item
                      labelCol={{ span: 24 }}
                      // initialValue={form.getFieldValue().category_id}
                      label="Category"
                      name="category_id"
                      rules={[
                        {
                          required: true,
                          message: "Please select a category",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select Category"
                        size="large"
                        className="select-style dark-field"
                        onChange={onCategoryChange}
                        value={category ? category : undefined}
                      >
                        <Option value="all">All</Option>
                        {categoryOptions?.map((option) => {
                          return (
                            <Option value={option?.category_id}>
                              {option?.gen_category?.name} {" > "}
                              {option?.category_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : null}

                  {subCategoryOptions?.length ? (
                    <Form.Item
                      labelCol={{ span: 24 }}
                      // initialValue={form.getFieldValue().sub_category_id}
                      label="Sub Category"
                      name="sub_category_id"
                      rules={[
                        {
                          required: true,
                          message: "Please select a sub category",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Sub Category"
                        size="large"
                        className="select-style dark-field"
                        onChange={onSubCategoryChange}
                        value={subCategory ? subCategory : undefined}
                      >
                        <Option value="all">All</Option>
                        {subCategoryOptions?.map((option) => {
                          return (
                            <Option value={option?.sub_category_id}>
                              {option?.gen_category?.name} {" > "}
                              {option?.category?.category_name} {" > "}
                              {option?.sub_category_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : null}
                </div>
                <div className="form-styling">
                  <Form.Item
                    name="banner"
                    labelCol={{ span: 24 }}
                    label="Upload Banner"
                  >
                    <Form.Item
                      name="banner"
                      labelCol={{ span: 24 }}
                      label="Upload Banner"
                      // valuePropName={formState !== 'edit' && 'fileList'}
                      //initialValue={formState === "add" ? null : form.getFieldValue().banner}
                      //isImageUrl={formState === "add" ? null : "https://cdn.pixabay.com/photo/2017/02/09/21/08/wings-2053515__340.png"}
                      getValueFromEvent={normFile}
                      noStyle
                      multiple={false}
                      rules={[
                        {
                          required: true,
                          message: "Please Upload Banner Image",
                        },
                      ]}
                    >
                      <Upload.Dragger
                        className="upload-image-review"
                        {...uploadProps}
                        name="banner"
                        // defaultFileList={
                        //   formState === "edit" &&
                        //   form.getFieldValue()?.banner === null
                        //     ? null
                        //     : [
                        //         {
                        //           url: form.getFieldValue()?.banner,
                        //         },
                        //       ]
                        // }
                        // defaultFileList={
                        //   formState === 'edit'
                        //     ? sampleBanner || form.getFieldValue()?.banner === null
                        //       ? form.getFieldValue()?.banner
                        //       : form.getFieldValue()?.banner?.length === 1
                        //         ? form.getFieldValue()?.banner
                        //         : [
                        //           {
                        //             url: form.getFieldValue()?.banner,
                        //           },
                        //         ]
                        //     : null
                        // }
                        // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      >
                        {/* <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                          </p> */}
                        <p className="ant-upload-text">
                          drag files here to upload
                        </p>
                        {/* <p className="ant-upload-hint">
                            Support for a single or bulk upload.
                          </p> */}
                      </Upload.Dragger>
                    </Form.Item>
                  </Form.Item>
                </div>
              </div>
              <div className="col-md-5">
                <div className="modal-video-review-box review-video">
                  <ReactPlayer
                    className={`review_react_player ${
                      videoData?.media_url?.split(".")[
                        videoData?.media_url?.split(".")?.length - 1
                      ] === "m3u8" && "objectFit"
                    }`}
                    width={"100%"}
                    height={"100%"}
                    url={videoData?.media_url}
                    controls
                    playsinline
                  />
                </div>
              </div>
            </div>
            <div className="row mr-0">
              <div className="col-md-3">
                <label className="pb-0">Promo Code</label>
                <Select
                  size="small"
                  filterOption={(input, options) =>
                    options.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={
                    productPromoCodePromo
                      ? productPromoCodePromo
                      : "Select PromoCode"
                  }
                  //disabled={!(formState === "add" || formState === "edit")}
                  placeholder="Select PromoCode"
                  //loading={this.state.promoCond}
                  optionFilterProp="children"
                  className="w-100 select-modal mb-20"
                  // onSearch={onSearch}
                  onChange={(options, e) => {
                    changePromoCode(e, options);
                    setFlag(true);
                  }}
                  showSearch
                  allowClear={false}
                  loading={promoRequest?.loading ? true : false}
                  disabled={promoRequest?.loading ? true : false}
                >
                  {promoRequest?.message?.map((customer, key) => {
                    return (
                      <Option key={customer.promo_percent + " " + key}>
                        {customer.promo}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              <div className="col-md-3">
                <label>Discount</label>
                <div className="promo_discount form-control mb-20">
                  {productPromoCodeDscs}
                </div>
              </div>

              <div className="col-md-3">
                <label>Referral Fee</label>
                <Form.Item
                  labelCol={{ span: 24 }}
                  // label="Referral Fee"
                  className="mb-20 label-padb-0 w-100"
                  name="referral_percent"
                >
                  <InputNumber
                    className="w-100 select-modal"
                    defaultValue={0}
                    size="large"
                    min={0}
                    max={100}
                    formatter={(value) => `${value}%`}
                    parser={(value) => value.replace("%", "")}
                    onChange={(e) => {
                      {
                        setReferralPercent(e);
                        setFlag(true);
                      }
                    }}
                  />
                </Form.Item>
              </div>
            </div>
            <div class="row">
              <div className="col-12">
                <div className="form-styling">
                  <Form.Item name="productsku">
                    <Form.Item
                      name="productsku"
                      label="Product SKU"
                      labelCol={{ span: 24 }}
                      className="d-flex flex-column sku-field pos-index mb-0"
                      // rules={[
                      //   {
                      //     required: true,
                      //     // message: 'Please Select Product Sku',
                      //   },
                      //   {
                      //     validator: async (_) => {
                      //       if (sku.length === 0) {
                      //         return Promise.reject(
                      //           new Error('Please Select Product SKUcccccccc')
                      //         );
                      //       } else {
                      //         return Promise.resolve();
                      //       }
                      //     },
                      //   },
                      // ]}
                    >
                      <AsyncProduct
                        getSku={getSku}
                        sku={sku}
                        // referralPercent={referralPercent}
                        // influencer_percent={influencer_percent}
                      />
                      {skuError && (
                        <div
                          role="alert"
                          className="ant-form-item-explain-error"
                        >
                          Please Select Product SKU
                        </div>
                      )}
                    </Form.Item>
                  </Form.Item>
                  <div className="row d-flex mb-20 product-listing-table-main">
                    <div className="col">
                      {sku?.length > 0 && (
                        <Table
                          pagination={false}
                          columns={columns}
                          size="small"
                          className="product-listing-table"
                          //  rowSelection={{ ...rowSelection }}
                          dataSource={[...sku]}
                          scroll={
                            sku.length > 2 ? { y: 145, x: 1000 } : { x: 1000 }
                          }
                          // scroll={
                          //   sku.length > 4
                          //     ? { y: 270, x: window.innerWidth <= 1440 ? 900 : 0 }
                          //     : false
                          // }
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-md-end">
                  <Button
                    className="default-btn fw-normal d-flex align-items-center justify-content-center"
                    type="primary"
                    size="large"
                    htmlType="submit"
                    loading={saveLoading}
                  >
                    Save
                  </Button>
                  <Button
                    key="back"
                    className="default-btn  fw-normal outline d-flex align-items-center justify-content-center"
                    onClick={handleCancel}
                  >
                    Exit
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </Modal>
      )}
      <Modal
        maskClosable={false}
        className="modal-generic modal-600"
        centered
        visible={isModalOpenDetail}
        onOk={handleOkDetail}
        onCancel={handleCancelDetail}
        closeIcon={<FontAwesomeIcon icon={faXmark} />}
        // footer={false}
        footer={[
          <Button
            key="back"
            onClick={handleCancelDetail}
            className="d-table m-auto"
          >
            Exit
          </Button>,
          // <Button key="submit" type="primary"
          //   className="d-table m-auto"
          //   // onClick={handleOk}
          //   // onClick={handleCancel}
          // >
          //   Submit
          // </Button>,
        ]}
      >
        <h2 className="modal-hd1">Details</h2>
        <div className="co">
          <Table
            pagination={false}
            columns={columnDetails}
            size="small"
            className="product-listing-tabl inventory-box-main details-table"
            //  rowSelection={{ ...rowSelection }}
            dataSource={dataDetails}
            // scroll={{
            //     x: 500,
            //     y: 500,
            // }}
            scroll={dataDetails?.length > 10 ? { y: 400, x: 500 } : { x: 500 }}
          />
        </div>
      </Modal>
    </div>
  );
}
function mapStateProps({ getInfluencerVideo }) {
  return { getInfluencerVideo };
}
export default connect(mapStateProps, {
  ...influencerReviewAction,
})(LinkProducts);
